export const whatLinks = [
  {
    path: "/news/",
    text: "News",
  },
  {
    path: "/projects/",
    text: "Projects",
  },
  {
    path: "/international-tours/",
    text: "Recent Tours",
  },
]

export const artistLinks = [
  {
    path: "/artists/",
    text: "All Artists",
  },
  {
    path: "/soloists/",
    text: "Soloists",
  },
  {
    path: "/orchestras/",
    text: "Orchestras",
  },
]

export const whoLinks = [
  {
    path: "/about/",
    text: "About",
  },
  {
    path: "/team/",
    text: "Team",
  },
  {
    path: "/contact/",
    text: "Contact",
  },
]
